import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=0df8306c&scoped=true&lang=pug"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=0df8306c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8306c",
  null
  
)

export default component.exports